import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw1708Handlers = [
  http.post(PlessService.SERVICE.registMultipleCodeImageInfo.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(registMultipleCodeImageInfoResponce);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
]

const registMultipleCodeImageInfoResponce = {
  status: "ok",
  message: "処理完了"
}